<script lang="ts" setup>
import { twMerge } from "tailwind-merge";
import type { HTMLAttributes } from "vue";
import ScrollArea from "../scroll-area/ScrollArea.vue";
import ScrollBar from "../scroll-area/ScrollBar.vue";

const props = defineProps<{
	class?: HTMLAttributes["class"];
}>();
</script>

<template>
	<ScrollArea class="flex-auto w-0 py-2.5 relative">
		<nav
			aria-label="breadcrumb"
			:class="
				twMerge(
					'after:block after:absolute after:-right-px after:top-0 after:h-full after:w-8 after:bg-linear-to-r after:from-transparent after:to-background',
					props.class,
				)
			"
		>
			<slot />
		</nav>
		<ScrollBar orientation="horizontal" />
	</ScrollArea>
</template>
